
export const formFileds = [
    {
        name: "accountName",
        placeholder: "AWS-Sandbox_account",
        label: "Account Name",
        gridSize: 6,
    },
    {
        name: "accountEmail",
        placeholder: "root+<account name>@altimetrik.com",
        label: "Account Email",
        gridSize: 6,
        disabled: true,
    },
    {
        name: "ouName",
        placeholder: "Sandbox Basic",
        label: "Organizational Unit",
        type: "select",
        gridSize: 6,
    },
    {
        name: "ssoEmail",
        placeholder: "user12@altimetrik.com",
        label: "SSO Email",
        gridSize: 6,
    },
    {
        name: "ssoFirstName",
        placeholder: "Enter your first name",
        label: "SSO First Name",
        gridSize: 6,
    },
    {
        name: "ssoLastName",
        placeholder: "Enter your last name",
        label: "SSO Last Name",
        gridSize: 6,
    },
    {
        name: "type",
        placeholder: "nonprod",
        label: "Type",
        type: "select",
        gridSize: 6,
        isCustom: true,
    },
    {
        name: "budget",
        placeholder: "In numbers",
        label: "Budget",
        type: "number",
        gridSize: 6,
        isCustom: true,
    },
    {
        name: "budgetNotificationRecipients",
        label: "Budget Notification Recipients",
        placeholder: "abc***@xyz.com,efgh**@ijk.com",
        isCustom: true,
        gridSize: 12,
    },
    {
        name: "cloudCustodian",
        label: "Cloud Custodian",
        gridSize: 5,
        isCustom: true,
    },
];
